<template>
  <div class="secondPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">IMMERSIVE</span>
      <span class="front">沉浸式培训典型应用场景</span>
    </div>
    <div>
      <el-row type="flex" class="scenes row-bg" justify="space-around">
        <el-col :span="3" v-for="(item,index) in scenes" :key="index">
          <div class="sceneBox">
            <div class="triangle_border_right"
              :style="{'border-left-color':(item.isBlue?'blue':'lightgray'),'margin-top':(index%2==0?'20px':'-20px')}">
              <span :style="{color:item.isBlue?'white':'black'}">
                {{item.num}}

              </span>
            </div>
            <div class="title">
              <span :style="{color:item.isBlue?'blue':'black'}">{{item.title}}</span>
            </div>
            <div class="content">
              <span>{{item.content}}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>

</template>

<script>
export default {
  name: "secondPage",
  data() {
    return {
      scenes: [
        {
          num: "01",
          title: "员工参加培训积极性低",
          titleColor: "black",
          content:
            "员工对于讲授式培训的参与积极性不高。具体表现如报名率低，请假率高，课堂投入度低",
          isBlue: false,
        },
        {
          num: "02",
          title: "复杂技能的学习",
          titleColor: "blue",
          content:
            "需要综合练习而非单项技能练习的学习主题，如战略制定、问题分析解决、项目管理、执行力提升等",
          isBlue: true,
        },
        {
          num: "03",
          title: "团队学习",
          titleColor: "black",
          content:
            "培训目标不仅仅针对个人，而是团队，如协作沟通、打破部门墙、提升团队绩效、变革管理等主题",
          isBlue: false,
        },
        {
          num: "04",
          title: "具有丰富工作经验的员工",
          titleColor: "black",
          content:
            "如中高级管理人员，他们的认知模式固化，对于培训主题有较高的“学习免疫力”，专家讲授、知识输入、工具赋能这些方式较难驱动学员的行为变化",
          isBlue: false,
        },
        {
          num: "05",
          title: "多次培训效果不好",
          titleColor: "black",
          content: "相同培训主题的课程曾多次进行，但课后员工工作绩效无明显提升",
          isBlue: false,
        },
        {
          num: "06",
          title: "学员人数超过40人",
          titleColor: "black",
          content:
            "如40人以上的大型团队集中培训，甚至是百人领导力课程，这都都是沉浸式培训所擅长的",
          isBlue: false,
        },
        {
          num: "07",
          title: "部分新生代员工（90/95后）",
          titleColor: "black",
          content: "个人价值主张鲜明，对于专家传授的学习方式接受度低，甚至抗拒",
          isBlue: true,
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
.secondPage {
  margin: 100px 0 150px 0;
}
.head {
  text-align: center;

  img {
    margin-left: -450px;
    z-index: 100;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    opacity: 0.2;
    z-index: 0;
  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}

.scenes {
  margin-top: 60px;
}

.sceneBox {
  //三角形
  .triangle_border_right {
    width: 0;
    height: 0;
    border-width: 40px 40px 40px 70px;
    border-style: solid;
    border-color: transparent transparent transparent lightgray; /*透明 透明 透明 灰*/
    margin: 30px 0 15px 0;
    position: relative;
    display: inline-flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    span {
      margin-right: 95px;
      font-size: 20px;
      font-family: "黑体";
      font-weight: bold;
    }
  }
  .title {
    text-align: left;
  }
  .content {
    margin-top: 10px;
    text-align: left;
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/secondPage.vue